export default __webpack_public_path__ + "static/media/liebherr-ik1624-21.54b65574.pdf";